import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../../context/PbxContext';

import { accessLocalStorage, valuesAnalyze, changeViewForms, changeIpInterfaces, readInterfaces } from '../../../services';
import FormIPSet from './formIpSetInterfaces';

import '../../../libs/bulma.min.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare } from '@fortawesome/free-solid-svg-icons';

function changeIp() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden, toggleIsChangeFormElements } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const history = useHistory();

  const [values, setValues] = useState({});
  const [validate, setValidate] = useState({});
  const [disable, setDisable] = useState(true);
  const [interfaces, setInterfaces] = useState([]);
  const [fullDataIfaces, setFullDataIfaces] = useState({});

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  /*
    [
      {
          "iface": "eth0",
          "ip": "192.168.88.2",
          "mask": "255.255.255.0",
          "gw": "192.168.88.1",
          "metric": 1
      },
      {
          "iface": "eth0.4000",
          "ip": "200.208.112.7",
          "mask": "255.255.255.248",
          "gw": "200.208.112.1",
          "metric": 100
      }
    ]
  */

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');
    const getNetworkData = await readInterfaces();
    const filterIfaces = getNetworkData.map((element) => {
      delete element['lo'];
      return element;
    });
    
    setInterfaces(Object.keys(...filterIfaces))
    Object.keys(...filterIfaces).forEach((i) => setValues((prevState) => prevState, values[i] = { "iface": i }));
    setFullDataIfaces(...filterIfaces)
  }, []);

  const changeScreen = (check, name) => {
    changeBorderImputToRedOrNormal(check, name);
    changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const { isIP, isMask, checkNumber } = valuesAnalyze;

    const itemCheck = name.split('-')[1];

    let checkValueIsCharacters = false;
    if (itemCheck === 'ip' || itemCheck === 'gw') checkValueIsCharacters = isIP(value);
    if (itemCheck === 'mask') checkValueIsCharacters = isMask(value);
    if (itemCheck === 'metric') checkValueIsCharacters = checkNumber(value);
    changeScreen(checkValueIsCharacters, name);
    return checkValueIsCharacters;
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;
    const element = name.split('-');
    const interfaceName = element[0];
    const prop = element[1];

    const itemStatus = handleChangeDataAnalyze(name, value);

    setValidate((prevState) => prevState, validate[name] = itemStatus === undefined  ? true : itemStatus);

    setValues((prevState) => prevState, values[interfaceName][prop] = value) ;
    if(Object.keys(validate).length%4 === 0) {
      Object.values(validate).includes(false) ? setDisable(true) : setDisable(false);
    } else {
      setDisable(true);
    }
    return;
  };

  const sendDataChangeIp = async () => {
    const ifacesPayloadUp = Object.values(values).filter((iface) => Object.values(iface).length > 1);
    const fetchEndpoints = await changeIpInterfaces(ifacesPayloadUp);
    console.log(fetchEndpoints)
    const result = Object.keys(fetchEndpoints).length > 0 ? true : false;
    if(result) {
      changeVisibityMessages(false, 'success-change-ip');
      toggleIsChangeFormElements('change-ip-div', 'is-hidden');
      toggleIsChangeFormElements('button-send-form', 'is-hidden');
      // setTimeout(() => {
      //   return history.push('/home');
      // }, 3000);
    };
    return;
  };

  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  return (
    <div>
      <div className="columns has-text-centered">
        <div className="column is-half is-offset-one-quarter has-text-centered">
          <strong className="is-size-3">ALTERAR IP</strong>
          <hr className="dropdown-divider"/>
        </div>
      </div>
      <article id="success-change-ip" name="success-change-ip" className="column is-half is-offset-one-quarter message is-info is-hidden">
        <div className="message-header">
          <p>Sucesso!</p>
          <button className="delete" aria-label="delete" onClick={ () => {
            toggleIsHidden('#success-change-ip');
            toggleIsHidden('#button-send-form');
            toggleIsHidden('#change-ip-div');
          }
          }></button>
        </div>
        <div className="message-body">
          Troca de IP realizada com <strong>sucesso</strong>!<br/>
          Necessário realizar reboot do sistema para as configurações entrarem em vigor!
        </div>
      </article>
      <div id="change-ip-div" name="change-ip-div" className="column is-full is-offset-1 has-text-centered">
      {
        interfaces.map((iface) => <FormIPSet key={ iface } iface={ iface } data={ fullDataIfaces[iface] } handleChangeValues={ handleChangeValues } />)
      }
      </div>
        <div className="columns mx-2">
          <div id="button-send-form" name="button-send-form" className="column mt-3 is-half is-4 is-offset-4 has-text-centered">
              <div className="control">
                <button className="button is-info is-fullwidth" type="submit" disabled={ disable } onClick={ () => sendDataChangeIp() }>
                  <span>
                    Trocar IP
                  </span>
                </button>
              </div>
          </div>
        </div>
      </div>
  );
}

export default changeIp;
